/**
 * Base API client for AskWingo backend.
 *
 * Uses axios with interceptors for auth headers and error handling.
 * Token is provided by AuthContext via the module-level getAuthToken() getter.
 */

import { config } from '@/config/environment';
import { getAuthToken } from '@/contexts/AuthContext';
import axios from 'axios';

const api = axios.create({
  baseURL: config.API_BASE_URL,
  timeout: 30_000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor — attach auth token from AuthContext
api.interceptors.request.use(
  (reqConfig) => {
    const token = getAuthToken();
    if (token) {
      reqConfig.headers.Authorization = `Bearer ${token}`;
    }
    return reqConfig;
  },
  (error) => Promise.reject(error),
);

// Response interceptor — handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      if (status === 401) {
        // AuthContext handles token expiry and redirect to login
        console.warn('Unauthorized — token may have expired');
      } else if (status === 403) {
        console.warn('Forbidden');
      } else if (status >= 500) {
        console.error('Server error:', error.response.data);
      }
    }
    return Promise.reject(error);
  },
);

export default api;
